import React from 'react';
import PropTypes from 'prop-types';
import { common } from '../../../../ts/react/common/constants/configConstants';

const { keyBoardEventCode } = common;
function ScrollBar({ scrollClassNames, scrollIconClassName, scroll, isDisabled }) {
  return (
    <div
      data-testid='game-carousel-scroll-bar'
      className={scrollClassNames}
      onClick={scroll}
      onKeyDown={e => {
        if (e.code === keyBoardEventCode.enter) {
          e.stopPropagation();
          e.preventDefault();
          scroll(e);
        }
      }}
      role='button'
      tabIndex={0}>
      <div className='arrow'>
        <span className={scrollIconClassName} />
      </div>
      <div className='spacer' />
    </div>
  );
}

ScrollBar.propTypes = {
  scrollClassNames: PropTypes.string.isRequired,
  scrollIconClassName: PropTypes.string.isRequired,
  scroll: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired
};

export default ScrollBar;
